import { ValueFormatterParams } from 'ag-grid-community';

export function formatIsoDateValue(params: ValueFormatterParams): string {
    if (!params.value) return '';
    const match = String(params.value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return String(params.value);
    return `${match[1]}-${match[2]}-${match[3]}`;
}
